const navigation = {
  nav: {
    home: "Home",
    about: "About Us",
    services: "Services",
    testimonials: "Happy Patients",
    gallery: "Gallery",
    contact: "Contact Us",
  },
  servicesMenu: {
    trigger: "Services",
    allServices: "View All Services",
  },
  serviceLinks: {
    implantology: {
      name: "Implantology",
      description: "High-quality, long-term tooth replacements",
    },
    endodontics: {
      name: "Endodontics",
      description: "Advanced root canal treatments",
    },
    "oral-surgery": {
      name: "Oral Surgery",
      description: "Precision oral surgical procedures",
    },
    periodontology: {
      name: "Periodontology",
      description: "Specialized gum treatments and care",
    },
    orthodontics: {
      name: "Orthodontics",
      description: "Expert treatments for misaligned teeth",
    },
    bonding: {
      name: "Bonding",
      description: "Cosmetic repairs with tooth-colored resin",
    },
    prosthetics: {
      name: "Prosthetics",
      description: "Custom-designed bridges and dentures",
    },
    cariesology: {
      name: "Cariesology",
      description: "Prevention and treatment of tooth decay",
    },
    "teeth-whitening": {
      name: "Teeth Whitening",
      description: "Professional teeth whitening for a brighter smile",
    },
    "dental-tourism": {
      name: "Dental Tourism",
      description: "Comprehensive dental care packages for international patients",
    },
    prices: {
      name: "Prices",
      description: "Up-to-date price list by service",
    },
  },
};

export default navigation;
